import { useEffect, useState } from 'react';
import { GetVehicleById, UpdateVehicleV1 } from '../../../../../reduxToolkit/Vehicle/VehicleApi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { VEHICLE_MODEL } from '../../../../../models/Vehicle';
import HandleChange from '../../../../../Helpers/HandleChange';
import { TABS_VEHICLE_UPDATE } from '../model/model';
import { toast } from 'react-toastify';
import defaultImages from '../../../../../assets/ImagesDefaults/ic-img-default-vehicle.svg';
import { getPhotoPicker, PHOTO_PICKER_MODEL } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg} from "../../../../../Apis/functions";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UpdateVehicleApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL, preview: defaultImages });
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [item, setItem] = useState({ ...VEHICLE_MODEL });
    const [emptyFields, setEmptyFields] = useState(false);
    const [modified, setModified] = useState(false);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const currentTime = new Date();

    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));

    // Initializes the step labels for the vehicle update flow based on translations.
    useEffect(() => {
        setSteps([t(TABS_VEHICLE_UPDATE.VEHICLE_DETAILS.TRANS), t(TABS_VEHICLE_UPDATE.PHOTO.TRANS)]);
    }, [t]);

    // Reloads vehicle data after a successful update.
    useEffect(() => {
        if (modified) {
            getData();

            setModified(false);
        }
    }, [modified]);

    /**
     * Fetches visitor and file data on initial load.
     */
    useEffect(() => {
        getData();
    }, []);

    /**
    * Retrieves vehicle information from the backend and
    * maps the response to the local form model.
    */
    const getData = () => {
        dispatch(GetVehicleById(params?.id)).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                setItem({
                    ...VEHICLE_MODEL,
                    ...data,
                    statusId: data?.status?.id,
                });
                if (data?.image) {
                    setPhotoPicker((prev) => ({ ...prev, previewImage: `data:image/png;base64,${data.image}` }));
                }
            },
        );
    };

    /**
     * Changes the active step in the UI.
     * @param {number} step - The index of the step to activate.
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    /**
     * Submits the updated visitor profile to the backend.
     */
    const handleUpdate = () => {
        if (!item.isValid()) {
            setEmptyFields(true);
            toast.warn(t('please_fill_all_fields'));
            return;
        }

        const imageFile = getPhotoPicker(photoPicker);
        dispatch(UpdateVehicleV1({ vehicleData: item.toRegister(), imageFile: imageFile })).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    setModified(true);
                    toast.success(t('has_been_updated_successfully'));
                }else{
                    errorMsg(code)
                }
            },
        );
    };


    return {
        DEV,
        permission,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        item,
        handleChange,
        emptyFields,
        currentTime,
        photoPicker,
        setPhotoPicker,
        handleUpdate,
        contractorId,
        supplierId,
    };
};

export default UpdateVehicleApp;
